import { Component, Input } from '@angular/core';
import {
	CustomFormAccessor,
	FormConfig,
} from 'src/shared/form-models/form-cva.component';
import {
	Customer,
	JobBillTo,
	JobPreferredBillingChannel,
	Railroad,
} from 'src/shared/api';
import { FormBuilder, NgControl, Validators } from '@angular/forms';

import { BillingDetails } from './billing-details.models';
import { ReplaySubject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { mapRailroadOrCustomerToCompany } from './billing-details.utility';
import { buildArrayFromEnum } from 'src/shared/utilities/utility-functions';

const billingDetailsFormConfig: FormConfig<BillingDetails> = {
	preferredBillingChannel: ['', [Validators.required]],
	billTo: ['', [Validators.required]],
	otherBillingCompany: [''],
	billingEmails: [''],
	billingNotes: [''],
	alternateBillingCustomer: [''],
};

@Component({
	selector: 'rpshared-billing-details',
	templateUrl: './billing-details.component.html',
})
export class BillingDetailsComponent extends CustomFormAccessor<
	BillingDetails
> {
	private readonly _billTo = new ReplaySubject<JobBillTo>(1);
	private readonly _billVia = new ReplaySubject<JobPreferredBillingChannel>(
		1
	);

	@Input() railroad: Railroad;
	@Input() customer: Customer;
	@Input()
	get editBillingInfo(): boolean {
		return this._editBillingInfo;
	}
	set editBillingInfo(value: boolean) {
		this._editBillingInfo = coerceBooleanProperty(value);
		this.checkAndUpdateBillingInfo();
	}

	private _editBillingInfo = false;

	readonly billTo$ = this._billTo.asObservable();
	readonly billVia$ = this._billVia.asObservable();

	readonly billVias = buildArrayFromEnum(JobPreferredBillingChannel);
	readonly billTos = buildArrayFromEnum(JobBillTo);
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, billingDetailsFormConfig);
	}

	writeValue(value: BillingDetails): void {
		if (value) {
			this.form.patchValue(value, { emitEvent: false });
			this.setBillTo(value.billTo);
			this.setBillVia(value.preferredBillingChannel);
			this.form.markAsUntouched();
		}
	}

	setBillTo(billTo: JobBillTo) {
		this._billTo.next(billTo);
		// TODO: uncomment when implementing RP-1057
		// this.checkAndUpdateBillingInfo();
	}

	setBillVia(billVia: JobPreferredBillingChannel) {
		this._billVia.next(billVia);
	}

	checkAndUpdateBillingInfo() {
		const currentOtherBillingCompany = this.form.get('otherBillingCompany')
			.value;
		const currentBillTo = this.form.get('billTo').value;

		if (currentBillTo === JobBillTo.Customer) {
			if (
				currentOtherBillingCompany?.id !== this.customer?.id &&
				currentOtherBillingCompany?.companyName !==
					this.customer?.companyName
			) {
				this.form.patchValue(
					{
						otherBillingCompany: {
							...mapRailroadOrCustomerToCompany(
								this.customer || {}
							),
							id: currentOtherBillingCompany.id,
						},
					},
					{ emitEvent: true }
				);
			}
		}
		if (currentBillTo === JobBillTo.Railroad) {
			if (
				currentOtherBillingCompany?.id !== this.railroad?.id &&
				currentOtherBillingCompany?.companyName !==
					this.railroad?.companyName
			) {
				this.form.patchValue(
					{
						otherBillingCompany: {
							...mapRailroadOrCustomerToCompany(
								this.railroad || {}
							),
							id: currentOtherBillingCompany?.id,
						},
					},
					{ emitEvent: true }
				);
			}
		}
	}
}
